import Swiper from 'swiper'
import { Navigation, Scrollbar } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/scrollbar'

export class IndexVoiceSlider {
  constructor() {
    this.slider = document.querySelector('.js-index_voice_slider')
    if (!this.slider) return

    let swiper
    const initSwiper = () => {
      swiper = new Swiper(this.slider, {
        modules: [Navigation, Scrollbar],
        slidesPerView: 1,
        speed: 500,
        spaceBetween: 20,
        navigation: {
          nextEl: `.p-index_voice .js-slider_button.-next`,
          prevEl: `.p-index_voice .js-slider_button.-prev`,
        },
        scrollbar: {
          el: '.p-index_voice .js-slider_scrollbar',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        },
      })
    }

    initSwiper()
  }
}
